import { getInactiveStepIds } from 'features/libra/workflow/inactiveSteps'
import { useWorkflow } from 'features/libra/WorkflowContext'
import { useMemo } from 'react'

import { useTicketAccess } from './TicketAccessContext'

/** Steps the ticket's current field values route past. */
export function useInactiveStepIds(): ReadonlySet<string> {
  const workflow = useWorkflow()
  const { fieldValues } = useTicketAccess()

  return useMemo(
    () => getInactiveStepIds(workflow, fieldValues),
    [workflow, fieldValues]
  )
}
